export const allowedFileTypes = {
  'Compressed Files': {
    mimeTypes: [
      'application/x-rar',
      'application/x-rar-compressed',
      'application/x-zip-compressed',
      'application/octet-stream',
      'application/zip',
      'application/x-7z-compressed'
    ],
    extensions: ['.rar', '.zip', '.7z']
  },
  'Excel Sheet': {
    mimeTypes: [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
      'application/vnd.ms-excel.sheet.macroEnabled.12',
      'application/vnd.ms-excel.template.macroEnabled.12',
      'application/vnd.ms-excel.addin.macroEnabled.12',
      'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
    ],
    extensions: ['.xla', '.xlsx', '.xltx', '.xlsm', '.xltm', '.xlam', '.xlsb', '.xls']
  },
  Image: {
    mimeTypes: [
      'image/bmp',
      'image/cis-cod',
      'image/gif',
      'image/ief',
      'image/jpeg',
      'image/pipeg',
      'image/svg+xml',
      'image/tiff',
      'image/x-cmu-raster',
      'image/x-cmx',
      'image/x-icon',
      'image/x-portable-anymap',
      'image/x-portable-bitmap',
      'image/x-portable-graymap',
      'image/x-portable-pixmap',
      'image/x-rgb',
      'image/x-xbitmap',
      'image/x-xpixmap',
      'image/x-xwindowdump',
      'image/png'
    ],
    extensions: [
      '.bmp',
      '.cod',
      '.gif',
      '.ief',
      '.jpeg',
      '.jpg',
      '.jfif',
      '.svg',
      '.tiff',
      '.tif',
      '.ras',
      '.cmx',
      '.ico',
      '.pnm',
      '.pbm',
      '.pgm',
      '.ppm',
      '.rgb',
      '.xbm',
      '.xpm',
      '.xwd',
      '.png'
    ]
  },
  'Outlook mail message': {
    mimeTypes: ['application/vnd.ms-outlook'],
    extensions: ['.msg']
  },
  'Power Point': {
    mimeTypes: [
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'application/vnd.openxmlformats-officedocument.presentationml.template',
      'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
      'application/vnd.ms-powerpoint.addin.macroEnabled.12',
      'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
      'application/vnd.ms-powerpoint.template.macroEnabled.12',
      'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
    ],
    extensions: ['.pps', '.pptx', '.potx', '.ppsx', '.ppam', '.pptm', '.potm', '.ppsm']
  },
  'Text Files': {
    mimeTypes: [
      'text/plain',
      'text/h323',
      'text/iuls',
      'text/richtext',
      'text/tab-separated-values',
      'text/webviewhtml',
      'text/x-component',
      'text/x-setext',
      'text/x-vcard',
      'text/csv',
      'application/vnd.ms-excel',
      'text/xml',
      'application/xml'
    ],
    extensions: ['.txt', '.323', '.uls', '.rtf', '.tsv', '.htt', '.htc', '.etx', '.vcf', '.vcard', '.csv', '.xml']
  },
  'Word Document': {
    mimeTypes: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
      'application/vnd.ms-word.document.macroEnabled.12',
      'application/x-pdf',
      'application/vnd.ms-word.template.macroEnabled.12'
    ],
    extensions: ['.pdf', '.doc', '.docx', '.dotx', '.docm', '.dotm']
  },
  Video: {
    mimeTypes: ['video/mp4'],
    extensions: ['.mp4']
  },
  'Encrypted Files': {
    mimeTypes: ['application/pgp-encrypted', 'application/octet-stream'],
    extensions: ['.pgp', '.gpg']
  }
};

export const extensionToMimeTypeMapping = {
  323: ['text/h323'],
  '7z': ['application/x-7z-compressed'],
  bmp: ['image/bmp'],
  cmx: ['image/x-cmx'],
  cod: ['image/cis-cod'],
  csv: ['text/csv', 'application/vnd.ms-excel'],
  doc: ['application/msword'],
  docm: ['application/vnd.ms-word.document.macroEnabled.12'],
  docx: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  dotm: ['application/vnd.ms-word.template.macroEnabled.12'],
  dotx: ['application/vnd.openxmlformats-officedocument.wordprocessingml.template'],
  etx: ['text/x-setext'],
  gif: ['image/gif'],
  htc: ['text/x-component'],
  htt: ['text/webviewhtml'],
  ico: ['image/x-icon'],
  ief: ['image/ief'],
  jfif: ['image/pipeg'],
  jpeg: ['image/jpeg'],
  jpg: ['image/jpeg'],
  msg: ['application/vnd.ms-outlook'],
  pbm: ['image/x-portable-bitmap'],
  pdf: ['application/pdf', 'application/x-pdf'],
  pgm: ['image/x-portable-graymap'],
  png: ['image/png'],
  pnm: ['image/x-portable-anymap'],
  potm: ['application/vnd.ms-powerpoint.template.macroEnabled.12'],
  potx: ['application/vnd.openxmlformats-officedocument.presentationml.template'],
  ppam: ['application/vnd.ms-powerpoint.addin.macroEnabled.12'],
  ppm: ['image/x-portable-pixmap'],
  pps: ['application/vnd.ms-powerpoint'],
  ppsm: ['application/vnd.ms-powerpoint.slideshow.macroEnabled.12'],
  ppsx: ['application/vnd.openxmlformats-officedocument.presentationml.slideshow'],
  pptm: ['application/vnd.ms-powerpoint.presentation.macroEnabled.12'],
  pptx: ['application/vnd.openxmlformats-officedocument.presentationml.presentation'],
  rar: ['application/x-rar', 'application/x-rar-compressed', 'application/octet-stream'],
  ras: ['image/x-cmu-raster'],
  rgb: ['image/x-rgb'],
  rtf: ['text/richtext'],
  svg: ['image/svg+xml'],
  tif: ['image/tiff'],
  tiff: ['image/tiff'],
  tsv: ['text/tab-separated-values'],
  txt: ['text/plain'],
  uls: ['text/iuls'],
  vcard: ['text/vcard'],
  vcf: ['text/vcard'],
  xbm: ['image/x-xbitmap'],
  xla: ['application/vnd.ms-excel'],
  xlam: ['application/vnd.ms-excel.addin.macroEnabled.12'],
  xls: ['application/vnd.ms-excel'],
  xlsb: ['application/vnd.ms-excel.sheet.binary.macroEnabled.12'],
  xlsm: ['application/vnd.ms-excel.sheet.macroEnabled.12'],
  xlsx: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  xltm: ['application/vnd.ms-excel.template.macroEnabled.12'],
  xltx: ['application/vnd.openxmlformats-officedocument.spreadsheetml.template'],
  xml: ['text/xml', 'application/xml'],
  xpm: ['image/x-xpixmap'],
  xwd: ['image/x-xwindowdump'],
  zip: ['application/zip', 'application/octet-stream', 'application/x-zip-compressed'],
  mp4: ['video/mp4'],
  gpg: ['application/pgp-encrypted', 'application/octet-stream'],
  pgp: ['application/pgp-encrypted', 'application/octet-stream']
};

export const fileIcon = {
  getFileIcon(file, separator = '.') {
    const fileType = file?.split(separator).pop().toLowerCase();

    switch (fileType) {
      case 'jpg':
      case 'png':
      case 'jpeg':
      case 'heif':
      case 'heic':
      case 'bmp':
        return 'image';

      case 'pdf':
        return 'picture_as_pdf';

      case 'txt':
        return 'draft';

      case 'doc':
      case 'docx':
      case 'odt':
        return 'docs';

      case 'xls':
      case 'xlsx':
        return 'table_view';

      case 'json':
        return 'file_json';

      case 'csv':
        return 'csv';

      case 'zip':
      case 'rar':
        return 'folder_zip';

      case 'mp4':
      case 'avi':
      case 'mkv':
        return 'video_file';

      case 'mp3':
      case 'wav':
        return 'audio_file';

      case 'html':
      case 'css':
      case 'js':
        return 'code';

      default:
        return 'draft';
    }
  }
};

export const fileTypes = Object.keys(allowedFileTypes);
export const extensions = Object.keys(extensionToMimeTypeMapping);
export const extentionList = extensionToMimeTypeMapping;

export const isPreviewable = (file) => {
  if (!file || typeof file !== 'string') return false;
  const ext = file.split('.').pop().toLowerCase();
  return [
    'pdf',
    'png',
    'jpg',
    'jpeg',
    'gif',
    'svg',
    'webp',
    'txt',
    'html',
    'json',
    'xml',
    'mp3',
    'mp4',
    'webm',
    'xlsx',
    'xls',
    'docx',
    'doc',
    'pptx',
    'ppt',
    'msg',
    'csv'
  ].includes(ext);
};
